import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { logoutAdmin } from '../store/slices/authSlice';
import { Button } from '../components/ui/button';
import { BarChart, Users, UsersRound, ShoppingBag, User } from 'lucide-react';
import { Link } from 'react-router-dom';

const DashboardLayout = ({ children }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { admin: currentAdmin } = useSelector(state => state.auth);

  const handleLogout = async () => {
    try {
      await dispatch(logoutAdmin()).unwrap();
      navigate('/auth/login');
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  const isActive = (path) => {
    if (path === '/dashboard') {
      return location.pathname === '/dashboard';
    }
    return location.pathname.startsWith(path);
  };

  return (
    <div className="min-h-screen bg-gray-100">
      {/* Header */}
      <header className="bg-white shadow">
  <div className="max-w-7xl mx-auto py-4 px-4 sm:px-6 lg:px-8 flex justify-between items-center">
    {/* Logo */}
    <Link to="/" className="flex items-center gap-2">
      <img
        src="/assets/klm-logo.png"
        alt="KLM Logo"
        className="h-10 sm:h-14 w-auto"
      />
      <span
        className="text-xl sm:text-4xl font-extrabold tracking-wide"
        style={{ color: '#D0001B', fontFamily: 'Arial Black, Arial, sans-serif', letterSpacing: '0.04em' }}
      >
        KLMKART
      </span>
    </Link>

    {/* Heading - hidden on mobile */}
        <h1 className="hidden sm:block text-xl font-semibold text-gray-900">Admin Dashboard</h1>

    <button
      onClick={handleLogout}
      className="px-3 py-1.5 sm:px-4 sm:py-2 text-sm font-medium text-white bg-red-600 rounded-md hover:bg-red-700"
    >
      Logout
    </button>
  </div>
</header>

      {/* Navigation Tabs - NEW SECTION */}
      <nav className="bg-white border-b shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex space-x-4 py-4 overflow-x-auto">
            <Button
              variant={isActive('/dashboard') ? 'default' : 'outline'}
              onClick={() => navigate('/dashboard')}
              size="sm"
            >
              <BarChart className="h-4 w-4 mr-2" />
              Overview
            </Button>
            
            {currentAdmin?.role === 'SUPER_ADMIN' && (
              <>
                <Button
                  variant={isActive('/dashboard/admins') ? 'default' : 'outline'}
                  onClick={() => navigate('/dashboard/admins')}
                  size="sm"
                >
                  <Users className="h-4 w-4 mr-2" />
                  Admin Management
                </Button>
                
                <Button
                  variant={isActive('/dashboard/users') ? 'default' : 'outline'}
                  onClick={() => navigate('/dashboard/users')}
                  size="sm"
                >
                  <UsersRound className="h-4 w-4 mr-2" />
                  User Management
                </Button>
                
                <Button
                  variant={isActive('/dashboard/products') ? 'default' : 'outline'}
                  onClick={() => navigate('/dashboard/products')}
                  size="sm"
                >
                  <ShoppingBag className="h-4 w-4 mr-2" />
                  Product Management
                </Button>

                <Button
                  variant={isActive('/dashboard/orders') ? 'default' : 'outline'}
                  onClick={() => navigate('/dashboard/orders')}
                  size="sm"
                >
                  <ShoppingBag className="h-4 w-4 mr-2" />
                  Order Management
                </Button>

                <Button
                  variant={isActive('/dashboard/maintenance') ? 'default' : 'outline'}
                  onClick={() => navigate('/dashboard/maintenance')}
                  size="sm"
                >
                  <ShoppingBag className="h-4 w-4 mr-2" />
                  Maintenance Management
                </Button>
              </>
            )}
            
            <Button
              variant={isActive('/dashboard/profile') ? 'default' : 'outline'}
              onClick={() => navigate('/dashboard/profile')}
              size="sm"
            >
              <User className="h-4 w-4 mr-2" />
              Profile
            </Button>
          </div>
        </div>
      </nav>

      {/* Main content */}
      <main className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
        {children}
      </main>
    </div>
  );
};

export default DashboardLayout;